var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full overflow-hidden",staticStyle:{"padding-bottom":".1rem"}},[_c('LineChart',{attrs:{"chart-width":"100%","chart-height":"100%","isSmooth":"","symbol":"round","chartRight":"2%","yName":"单位：次","chart-data":_vm.inboundAndOutboundChartData,"show-legend":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }